import $i18n from 'panda-i18n';
import React from 'react';
import { CnButtonGroup } from '@/components/cn-button-group';
import { CnButton } from '@/components/cn-button';
import { CnBox } from '@/components/cn-box';
import { CnCheckbox } from '@/components/cn-checkbox';
import './index.scss';
export const Toolbar = (props) => {
    const { showSelect, totalCount, primaryKey, selectedKeys, setSelectedKeys, selectedDataSource, dataSource, toolbarButtons, } = props;
    const showTotal = totalCount && totalCount !== 0;
    const showInfo = showSelect || showTotal;
    const showButtons = Boolean(toolbarButtons.length);
    const checked = Boolean(selectedKeys.size);
    const indeterminate = Boolean(selectedKeys.size && selectedKeys.size !== dataSource.length);
    return (React.createElement("div", { className: "cn-ui-m-card-items-toolbar" },
        showInfo ? (React.createElement("div", { className: "cn-ui-m-card-items-toolbar-info" }, showTotal ? (React.createElement(CnBox, { direction: "row", align: "center", spacing: 12 },
            showSelect ? (React.createElement(CnCheckbox, { className: "cn-ui-m-card-items-toolbar-info-select-all", size: "medium", checked: checked, indeterminate: indeterminate, onChange: (v) => {
                    if (v || indeterminate) {
                        setSelectedKeys(new Set(dataSource.map((_) => _[primaryKey])));
                    }
                    else {
                        setSelectedKeys(new Set());
                    }
                } }, $i18n.get({
                id: 'SelectAll',
                dm: '全选',
                ns: 'CnCardItems',
            }))) : null,
            React.createElement("div", { className: "cn-ui-m-card-items-toolbar-info-total" },
                showSelect ? (React.createElement("span", null, $i18n.get({
                    id: 'Selected',
                    dm: '已选',
                    ns: 'CnCardItems',
                }))) : null,
                showSelect ? (React.createElement("span", { className: "cn-ui-m-card-items-toolbar-info-select-count" }, selectedKeys.size)) : null,
                showSelect ? (React.createElement("span", null, $i18n.get({
                    id: 'Article',
                    dm: '条',
                    ns: 'CnCardItems',
                }))) : null,
                showSelect ? (React.createElement("span", { className: "cn-ui-m-card-items-toolbar-info-line" }, "/")) : null,
                React.createElement("span", null, $i18n.get({
                    id: 'ATotalOfTotalCount',
                    dm: '共{totalCount}条',
                    ns: 'CnCardItems',
                }, { totalCount }))))) : null)) : null,
        showInfo && showButtons ? (React.createElement("div", { className: "cn-ui-m-card-items-toolbar-space" })) : null,
        showButtons ? (React.createElement(CnButtonGroup, { className: "cn-ui-m-card-items-toolbar-buttons", fullWidth: true, isReverse: true, size: "large" }, toolbarButtons.map((button, i) => {
            const { onClick, disabled, children } = button;
            return (React.createElement(CnButton, { key: `${Date.now() + i}`, disabled: disabled, onClick: (e) => onClick?.(e, [...selectedKeys], selectedDataSource) }, children));
        }))) : null));
};
